import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import Header from "./components/Header";
import Footer from "./components/Footer";

import { BrowserRouter, MemoryRouter } from "react-router-dom";

import "./index.css";

const baseUrl = import.meta.env.BASE_URL || "/";

const normalizedBasename =
  baseUrl === "/" ? "/" : baseUrl.replace(/\/+$/, "");

const BUILD_ID =
  typeof __TRW_BUILD_ID__ !== "undefined" ? __TRW_BUILD_ID__ : null;

const checkForDeployedUpdate = () => {
  if (!BUILD_ID || typeof window === "undefined" || !window.fetch) return;

  const versionUrl = `${baseUrl}version.json?ts=${Date.now()}`;
  window
    .fetch(versionUrl, { cache: "no-store" })
    .then((res) => (res.ok ? res.json() : null))
    .then((payload) => {
      const deployedBuildId = payload?.buildId ? String(payload.buildId) : "";
      if (!deployedBuildId || deployedBuildId === BUILD_ID) return;

      const url = new URL(window.location.href);
      url.searchParams.set("v", deployedBuildId);
      window.location.replace(url.toString());
    })
    .catch(() => {});
};

const embeddedRoute =
  typeof window !== "undefined" &&
  typeof window.__TRW_EMBED_ROUTE__ === "string" &&
  window.__TRW_EMBED_ROUTE__.trim()
    ? window.__TRW_EMBED_ROUTE__.trim()
    : null;

const rootEl = document.getElementById("root");
const headerEl = document.getElementById("trw-header-placeholder");
const footerEl = document.getElementById("trw-footer-placeholder");

if (headerEl) {
  ReactDOM.createRoot(headerEl).render(<Header />);
}

if (footerEl) {
  ReactDOM.createRoot(footerEl).render(<Footer />);
}

if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    embeddedRoute ? (
      <MemoryRouter initialEntries={[embeddedRoute]}>
        <App />
      </MemoryRouter>
    ) : (
      <BrowserRouter basename={normalizedBasename}>
        <App />
      </BrowserRouter>
    )
  );
}

// Defer update checks so they don't compete with initial load/LCP requests.
if (typeof window !== "undefined") {
  const schedule =
    window.requestIdleCallback ||
    ((cb) => window.setTimeout(() => cb({ didTimeout: false, timeRemaining: () => 0 }), 2500));
  schedule(() => checkForDeployedUpdate());
}
